import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { SalesDocument } from '@icc/b2b/shared';
import { logger } from '@icc/shared/logger';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'icc-modify-order-dialog',
    templateUrl: './modify-order-dialog.component.html',
    styleUrls: ['./modify-order-dialog.component.scss'],
})
export class ModifyOrderDialogComponent {
    canBeModified = true;
    inProgress = false;

    message = '';
    messages: string[] = [];
    messageState: 'default' | 'error' = 'default';

    constructor(
        @Inject(DIALOG_DATA)
        public data: {
            document: SalesDocument;
            buyDocuments: SalesDocument[];
        },
        private translateService: TranslateService,
        private dialogRef: DialogRef,
        private http: HttpClient,
    ) {}

    async modify(mode: 'all' | 'sales') {
        this.canBeModified = false;
        this.inProgress = true;
        const document = this.data.buyDocuments.length > 0 ? this.data.buyDocuments[0] : this.data.document;
        this.message = this.translateService.instant(
            'SALES_DOCUMENT|Modyfikowanie zamówienia w systemie zewnętrznym.',
        );
        this.messages = [];
        this.messageState = 'default';
        try {
            const result = await this.http.post<{status: 'ok' | 'error';}>('/api/b2b/order-external/modify', {
                documentId: document.uuid,
                documentExternalId: document.externalId,
            }).toPromise();
            if (result.status === 'ok') {
                this.inProgress = false;
                this.message = '';
                this.messages = [];
                this.dialogRef.close({
                    mode,
                });
            }
        } catch (e) {
            logger.error(e);
            if (e.error?.messages?.length) {
                this.message = '';
                this.messages = e.error.messages;
            } else {
                this.message = this.translateService.instant(
                    'SALES_DOCUMENT|Zamówienie nie może zostać zmodyfikowane w systemie zewnętrznym. Spróbuj ponownie później.');
                this.messages = [];
            }
            this.messageState = 'error';
            this.canBeModified = true;
            this.inProgress = false;
        }
    }

    close() {
        this.dialogRef.close();
    }
}
